module.exports = __webpack_public_path__ + "img/MoonSword 4.1c2aece1.png";